'use client'

import { RestaurantCitySearchCategoryRow } from '@/features/restaurants/restaurants-city-search/restaurant-city-search-filters/restaurant-city-search-category-row'
import { RestaurantCitySearchFiltersInput } from '@/features/restaurants/restaurants-city-search/restaurant-city-search-filters/restaurant-city-search-filters-input'
import { RestaurantCitySearchFiltersOpenNow } from '@/features/restaurants/restaurants-city-search/restaurant-city-search-filters/restaurant-city-search-filters-open-now'
import { RestaurantCitySearchSorting } from '@/features/restaurants/restaurants-city-search/restaurant-city-search-filters/restaurant-city-search-sorting'

/**
 * Browse controls: emoji category row on top, below it the search taking all
 * remaining width with the open-now toggle and sorting to its right. On
 * mobile the search gets its own line above the two pills.
 */
export const RestaurantCitySearchFilters = () => {
    return (
        <div className="flex w-full flex-col gap-y-4 md:gap-y-6">
            <RestaurantCitySearchCategoryRow />

            <div className="flex flex-col gap-y-3 md:flex-row md:items-center md:gap-x-3">
                <div className="w-full md:w-auto md:flex-1">
                    <RestaurantCitySearchFiltersInput />
                </div>

                <div className="flex items-center justify-between gap-x-3 md:justify-start">
                    <RestaurantCitySearchFiltersOpenNow />

                    <RestaurantCitySearchSorting />
                </div>
            </div>
        </div>
    )
}
